export default __webpack_public_path__ + "static/media/kucoin-token-kcs-logo.0ab662af.svg";